<template>
  <div>
    <status-page :statusPageType="1" ></status-page>
  </div>
</template>
<script>
  import StatusPage from "./StatusPage.vue"
  export default {
    components: {
      StatusPage
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/StatusUpdates.vue